import React, { Component } from 'react';
// import Loading from '../Loading/Loading';
// import Geral from '../../Utils/Geral';

class ShippingStatus extends Component {
    render() {
        return (
            <>
                {/* <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                Status da remessa
                            </div>
                            <div className="card-body">
                                <div className="row align-items-end">
                                    <div className="col-6">
                                        <div className="form-inline">
                                            <label htmlFor="ddlShippingStatus">Status:</label>
                                            <select className="form-control mx-2">
                                                <option></option>
                                                <option>Aguardando entrega</option>
                                                <option>Entregue</option>
                                                <option>Cancelada</option>
                                            </select>
                                            <button className="btn btn-primary">Salvar status</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </>
        
        )
    }
}

export default ShippingStatus;